import React from 'react'
import type { Props } from './types'
import * as S from './VisuallyHidden.styled'

export const VisuallyHidden = ({ children }: Props) => {
  return <S.VisuallyHidden>{children}</S.VisuallyHidden>
}
